<app-main-menu></app-main-menu>
<div class="content-socai">
    <p-panel styleClass="margin-top-10">
        <ng-template pTemplate="icons">
            <button pButton pRipple class="p-panel-header-icon p-link" (click)="themSoCaiNav()" icon="pi pi-plus">
            </button>
            <button pButton pRipple class="p-panel-header-icon p-link" (click)="homeNav()" icon="pi pi-home">
            </button>
        </ng-template>
        <ng-template pTemplate="header">
            DANH SÁCH HỒ SƠ
        </ng-template>
        <div class="card">
            <p-fieldset legend="Thông tin tìm kiếm" [toggleable]="true">
                <form [formGroup]="searchForm" (submit)="timKiemSoCai()">
                    <div class="p-formgroup-inline">
                        <div class="p-field">
                            <label>Tìm kiếm trên</label>
                            <p-dropdown [options]="optionSearch" formControlName="optionSeachSelected"
                                optionLabel="name">
                            </p-dropdown>
                        </div>
                        <div class="p-field">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" placeholder="Nội dung tìm kiếm..."
                                    formControlName="searchValue" />
                            </span>
                        </div>
                        <div class="p-field">
                            <label>Từ ngày:</label>
                            <p-calendar formControlName="tuNgay" dateFormat="dd/mm/yy" [monthNavigator]="true"
                                (onSelect)="calendarChangeTuNgay($event)">
                            </p-calendar>
                        </div>
                        <div class="p-field">
                            <label>Đến ngày:</label>
                            <p-calendar formControlName="denNgay" dateFormat="dd/mm/yy" [monthNavigator]="true"
                                (onSelect)="calendarChangeDenNgay($event)">
                            </p-calendar>
                        </div>
                        <div class="p-field">
                            <button pButton pRipple type="submit" icon="pi pi-search" label="Tìm kiếm"
                                class="p-button-raised p-ml-1"></button>
                        </div>
                    </div>
                </form>

            </p-fieldset>
            <p-table [paginator]="true" [rows]="pageSize" [totalRecords]="this.totalRecords" [loading]="loading"
                [lazy]="true" [rowsPerPageOptions]="[10,25,50]" [value]="data" [(first)]="pageNumber"
                (onLazyLoad)="getSoCai($event)" [rowHover]="true" [(selection)]="itemChoosed"
                (onRowSelect)="onRowSelect($event)"
                styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 50px;" class="tvt-center-text">Số công chứng</th>
                        <th style="width: 60px;" class="tvt-center-text">Ngày công chứng</th>
                        <th style="width: 180px;" class="tvt-center-text">Họ tên, CMND/Hộ chiếu/CCCD ,Nơi cư trú của
                            người yêu cầu công chứng</th>
                        <th style="width: 120px;" class="tvt-center-text">Loại HĐ, giao dịch</th>
                        <!-- <th style="width: 120px;" class="tvt-center-text">Họ tên công chứng viên ký văn bản công chứng
                        </th> -->
                        <th style="width: 60px;" class="tvt-center-text">Phí công chứng</th>
                        <th style="width: 60px;" class="tvt-center-text">Thù lao công chứng, chi phí khác</th>
                        <th style="width: 190px;" class="tvt-center-text">Tài sản là đối tượng của hợp đồng, giao
                            dịch<br />(nếu có)
                        </th>
                        <th style="width: 120px;" class="tvt-center-text">Nghiệp vụ</th>
                        <th style="width: 60px;" class="tvt-center-text">Ghi chú</th>
                        <th style="text-align: center;width: 90px;">#</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10">
                            <p style="text-align: center; display:block; color:red;">Không có bản ghi nào</p>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr>
                        <td class="tvt-margin-padding-0" style="text-align: right;">{{data.socongchung}}</td>
                        <td class="tvt-margin-padding-0" style="text-align: right;">{{data.ngayCongChung | date:
                            'dd/MM/yyyy'}}</td>
                        <td class="tvt-margin-padding-0"
                            [innerHTML]="'<b>Bên A:</b>'+data.dsNYC_BenA+'<hr/><b>Bên B:</b>'+data.dsNYC_BenB"></td>
                        <td class="tvt-margin-padding-0">{{data.tenLoaiHopDong}}</td>
                        <!-- <td class="tvt-margin-padding-0">{{data.hoVaTenCongChungVien}}</td> -->
                        <td style="text-align: right;">{{data.phicongchung | number:'3.0'}}</td>
                        <td style="text-align: right;">{{data.chiphikhac | number:'3.0'}}</td>
                        <td class="tvt-margin-padding-0">{{data.thongtintaisan}}</td>
                        <td class="tvt-margin-padding-0">{{data.hoVaTenNguoiThucHien}}</td>
                        <td class="tvt-margin-padding-0">{{data.ghichu}}</td>
                        <td class="tvt-margin-padding-0" style="text-align: center;"><button *ngIf="data.LinkFile!=''"
                                pButton pRipple type="button" icon="pi pi-download"
                                class="p-button-rounded p-button-outlined p-mr-2"
                                (click)="downloadFile(data.id)"></button>
                            <button pButton pRipple type="button" icon="pi pi-pencil"
                                class="p-button-rounded p-button-outlined" (click)="suaSoCaiNav(data.id)"></button>
                            <button pButton pRipple type="button" icon="pi pi-trash"
                                class="p-button-rounded p-button-outlined p-ml-2" (click)="delete(data.id)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div style="display: flex;">
                        Tổng số bản ghi: <p style="color:red;margin: 0px 3px;">{{this.totalRecords}}</p>; Tổng phí công
                        chứng:<p style="color:red;margin: 0px 3px;">{{phi.phicongchung|number:'3.0'}}</p>; Chi phí
                        khác:<p style="color:red;margin: 0px 3px;">{{phi.phikhac|number:'3.0'}}</p>; Có <p
                            style="color:red;margin: 0px 3px;">{{this.data.length}}</p> bản ghi trong trang.
                    </div>
                </ng-template>
            </p-table>
        </div>
        <ng-template pTemplate="footer">
            <button pButton type="button" label="Xuất file excel" class="p-button-outlined" icon="fa fa-file-excel-o"
                (click)="exportExcel()"></button>
        </ng-template>
    </p-panel>
</div>